const isFile = (object: any) => {
  return object instanceof File;
}

const generateUniqueFileName = (file: File, index: number) => {
  const extension = file.name.split('.').pop();
  const nameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));
  return `${nameWithoutExtension}_${index}.${extension}`;
}

const convertData = (object: any): { files: File[], object: any } => {
  let files: File[] = [];
  let fileIndexMap = new Map<string, number>();

  const processObject = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(item => processObject(item));
    } else if (typeof obj === 'object' && obj !== null) {
      const result: any = {};
      for (const key of Object.keys(obj)) {
        if (isFile(obj[key])) {
          const file = obj[key];
          const count = fileIndexMap.get(file.name) || 0;
          fileIndexMap.set(file.name, count + 1);

          const uniqueName = generateUniqueFileName(file, count);
          files.push(new File([file], uniqueName, { type: file.type }));
          result[key] = uniqueName;
        } else {
          result[key] = processObject(obj[key]);
        }
      }
      return result;
    }
    return obj;
  };

  const processedObject = processObject(object);
  return { files, object: processedObject };
}

export const toMultipartFormData = (object: any) => {
  const { files, object: resultObject } = convertData(object);

  const form = new FormData();
  form.append("request", new Blob([JSON.stringify(resultObject)], {
    type: "application/json",
  }));

  files.forEach((file) => {
    form.append("files", file, file.name); // Используем измененное имя файла
  });

  return form;
}
